<template>
    <div class="checkbox-wrapper">
        <div v-if="showTitle" class="pl-0 v-expansion-panel-header text-subtitle-2">
            {{ $t(`filterTitles.${filter}`) }}
        </div>
        <div>
            <v-checkbox v-model="checked" density="compact" :value="checked" small hide-details class="py-0 my-0">
                <template v-slot:label>
                    <div class="label-wrapper full-width label-text ms-2">{{ label }}</div>
                </template>
            </v-checkbox>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {CheckboxFilter} from '@/components/search/filters/CheckboxFilter.vue'

    @Component
    export class CheckboxSingleFilter extends CheckboxFilter {
        @Prop({required: true}) label
        @Prop({default: false, type: Boolean}) showTitle
    }

    export default CheckboxSingleFilter
</script>

<style lang="scss" scoped>
    .label-wrapper {
        width: 100%;
    }

    .label-text {
        font-size: 13px;
    }

    .checkbox-container {
        max-height: 500px;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #ddd;
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #6699cc;
        border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b3d4fc;
    }

    :deep(.v-input__append-outer) {
        margin-left: auto;
    }

    .filter-qty {
        color: grey;
        font-size: 10px;
    }

    :deep(.v-expansion-panel-content__wrap) {
        padding: 0;
    }
</style>
